module.exports = __webpack_public_path__ + "static/3-9d09c307bb2a480798aee53201351ba7.jpg";